import {
  ConnectionError,
  NotFoundError,
  ServiceUnavailableError,
  UnauthorizedAccessError
} from '../../modules/app/errors';
import { SaveSlipConflictError } from './errors';

const POST_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};

export const slipUrl = (slipId = null) => {
  const idpath = slipId ? `/${slipId}` : '';
  return `${api_config.betting_buddy_api}/builtbet${idpath}`;
};

export const fetchSlips = () => fetch(slipUrl(), {
  credentials: 'include'
})
  .catch(e => {
    throw new ConnectionError(e.message);
  })
  .then(response => {
    const { status, statusText } = response;

    switch (status) {
      case 200: {
        return response.json();
      }
      case 403: {
        throw new UnauthorizedAccessError(statusText, status);
      }
      case 520: {
        throw new ServiceUnavailableError(statusText, status);
      }
      default: {
        throw new ConnectionError(statusText, status);
      }
    }
  });

export const saveSlip = (slipId, slip) => fetch(slipUrl(slipId), {
  method: slipId ? 'PUT' : 'POST',
  headers: POST_HEADERS,
  credentials: 'include',
  cache: 'no-cache',
  body: JSON.stringify(slip)
})
  .catch(e => {
    throw new ConnectionError(e.message);
  })
  .then(response => {
    const { status, statusText } = response;

    switch (status) {
      case 201:
      case 204: {
        return true;
      }
      case 403: {
        throw new UnauthorizedAccessError(statusText, status);
      }
      case 409: {
        throw new SaveSlipConflictError(statusText, status);
      }
      case 520: {
        throw new ServiceUnavailableError(statusText, status);
      }
      default: {
        throw new ConnectionError(statusText, status);
      }
    }
  });

export const deleteSlip = (slipId) => fetch(slipUrl(slipId), {
  method: 'DELETE',
  credentials: 'include',
  cache: 'no-cache'
})
  .catch(e => {
    throw new ConnectionError(e.message);
  })
  .then(response => {
    const { status, statusText } = response;

    switch (status) {
      case 204: {
        return true;
      }
      case 404: {
        throw new NotFoundError(statusText, status);
      }
      case 520: {
        throw new ServiceUnavailableError(statusText, status);
      }
      default: {
        throw new ConnectionError(statusText, status);
      }
    }
  });
